import defaultSettings from '../settings.json';
const initialState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {}
  },
  distributionList: []
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return { ...state,
          settings
        };
      }

    case 'update-userInfo':
      {
        const {
          userInfo = initialState.userInfo,
          userLoading
        } = action.payload;
        return { ...state,
          userLoading,
          userInfo
        };
      }

    case 'update-distributionList':
      {
        const {
          distributionList = initialState.distributionList
        } = action.payload;
        return { ...state,
          distributionList
        };
      }

    default:
      return state;
  }
}